var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-preview" },
    [
      _c("ClosePreviewComponent", {
        on: { "close-viewer-event": _vm.closeViewerEvent },
      }),
      _vm.isLoading
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer-component",
          })
        : _vm._e(),
      _c("ejs-documenteditorcontainer", {
        ref: "documentEditor",
        staticClass: "document-editor",
        attrs: {
          width: "100%",
          isReadOnly: true,
          restrictEditing: true,
          documentChange: _vm.onDocumentChange,
        },
        on: { failure: _vm.onServiceFailure },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }